/* BackupAction.js */

"use strict";

const BackupDetailComponent = require("./veils/backupdetail/BackupDetailComponent");
const BackupSummaryComponent = require("./veils/backupsummary/BackupSummaryComponent");
const _ = require("lodash");

class BackupAction {
    constructor(logger, gameEditor, modalUserFeedback, DeviceEntity, userSession, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceEntity = DeviceEntity;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._selectedDeviceIds = this._activeView
            ? this._activeView._gameEditor._device.getId()
            : [];
        this.userSession = userSession;
        this._selectedDevice = _.get(this._activeView._gameEditor, "_device");

        this.run = this.run.bind(this);
        this._backupDevices = this._backupDevices.bind(this);
    }

    run() {
        return this._modalUserFeedback
            .displayCustom(new BackupDetailComponent(this._logger, this), {
                dontHide: true,
            })
            .then(({name, runCapture}) => {
                return this._backupDevices(name, runCapture);
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn({error: err}, "ExportData action - User Canceled");
                    this._modalUserFeedback.hideDisplayed();
                } else {
                    this._logger.warn({error: err}, "ExportData action - Error");
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }

    _backupDevices(name, runCapture) {
        return Promise.resolve().then(() => {
            const workInput = {
                description:
                    name ||
                    `Backup - ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
                runCapture: runCapture,
            };

            const workTarget = {
                category: "entity",
                entityType: "Device",
                method: "multi",
                ids: [this._selectedDeviceIds],
            };

            const _progressCallBack = ({workId, successCount, failureCount, targetCount}) => {
                if (
                    _.isNumber(successCount) &&
                    _.isNumber(failureCount) &&
                    _.isNumber(targetCount)
                ) {
                    const msg = `Succeeded ${successCount}, failed ${failureCount} of ${targetCount} devices`;
                    this._modalUserFeedback.showLoadingProgress(msg);
                }
            };

            this._modalUserFeedback.displayLoading({
                message: "Backing up your device...",
                showHideButton: true,
            });

            return this._deviceEntity
                .runBackupWork(
                    this.userSession.activeOrganization.id,
                    workTarget,
                    workInput,
                    {launchAndForget: false},
                    _progressCallBack
                )
                .then((result) => {
                    if (!this._modalUserFeedback.isStillOpen || result.type === "schedule") {
                        return this._modalUserFeedback.hideDisplayed();
                    }

                    if (result.errorMsg) {
                        const err = new Error(result.errorMsg);
                        err.errorCode = "CaptureError";
                        err.errorMsg = result.errorMsg;
                        throw err;
                    }

                    return this._modalUserFeedback.displayCustom(
                        new BackupSummaryComponent(result, this._logger)
                    );
                })
                .catch((err) => {
                    if (err.userRejected) {
                        this._logger.warn({error: err}, "ImportAction.run() - User Canceled.");
                        return this._modalUserFeedback.hideDisplayed();
                    } else {
                        this._logger.warn({error: err}, "ImportAction.run() - Error");
                        return this._modalUserFeedback.displayError(err).catch(() => {
                            return Promise.resolve();
                        });
                    }
                });
        });
    }
}

module.exports = BackupAction;

BackupAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.userSession",
    "gameEditor.activeView",
];

BackupAction.$displayDetails = {
    type: "Action",
    name: "BackupAction",
    icon: "common.backup",
    title: "Backup device",
    shown: true,
    order: 3,
};
